<template>
  <div class="bg-[var(--fundoForm)] w-full p-2 rounded-md flex justify-center items-center text-[var(--text)]">
    <div class="w-full max-w-[800px] flex items-center justify-center">
      <!-- <div class="w-full max-w-[50%]">
        <GmapMap
         :center="{ lat: 10, lng: 10 }"
         :zoom="7"
         map-type-id="roadmap"
         style="width: 100%; height: 400px">
         <GmapMarker
          :position="{ lat: 10, lng: 10 }"
          :clickable="true"
          :draggable="true"
          />
        </GmapMap>
      </div> -->


      <div class="w-full max-w-[50%] ml-4">
        <form @submit.prevent="onSubmit" class="flex flex-col gap-2 text-black outline-none focus:ring-2 focus:ring-[#2e2e48] p-2">
          <div class="w-full grid grid-cols-2 items-center gap-1">
            <label for="host" style="color: var(--label);">API da GoogleMaps:</label>
            <input style="background-color: var(--label); color: var(--text);" v-model="api_key" type="password" class="rounded-md p-1 min-w-[30rem]" placeholder="Strings" />
          </div>
          <div class="text-right">
            <button v-if="validPermission('C0013')" style="color: var(--label); background-color: var(--button);" type="submit" class="px-4 py-1 bg-sky-600 rounded-lg shadow-lg hover:bg-sky-700 text-[var(--text)]">Salvar</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>





<script>
import { Map as GmapMap, Marker as GmapMarker } from 'vue2-google-maps'
import { toast } from 'vue3-toastify';
import Cookies from 'js-cookie'
import CryptoJS from 'crypto-js'
import mixin from '@/permissionMixin.js'
import axios from "axios";
import { id as loggedID } from '@/extraData'

export default {
mixins: [mixin],
name: 'MyMapComponent',
components: {
  GmapMap,
  GmapMarker
},

data() {
  return {
    baseURL: process.env.VUE_APP_URL_BASE,
    api_key: '',
    currentSchema: '',
  };
},
created() {
  // Decrypt the api_key when getting it from the cookie
  // const encryptedApiKey = Cookies.get('api_key');
  // console.log("encrypted key",encryptedApiKey);
  // if (encryptedApiKey) {
  //   const bytes = CryptoJS.AES.decrypt(encryptedApiKey, 'secret key 123');
  //   const originalText = bytes.toString(CryptoJS.enc.Utf8);
  //   this.api_key = originalText;
    
  // }

  this.fetchSchema();
  this.fetchEmpresaAPI();
},

methods: {
    async onSubmit() {
    if(this.api_key === '') {
      toast.error("Chave não pode ser vazia", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 1000,
      });
      return;
    }
  
    try {
      // Using axios instead of fetch
      const response = await axios.post(`${this.baseURL}/api/v1/dadosempresa/registrar/`, {
        chave_api: this.api_key,
        // Adicione outros campos que você deseja atualizar aqui
      });
  
      // Axios handles status codes automatically - success is implied if we reach here
      toast.success('Dados da empresa salvos com sucesso!', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000
      });
  
      // Recarrega os dados para refletir a atualização
      await this.fetchEmpresaAPI();
    } catch (error) {
      console.error('Erro ao atualizar chave:', error);
      
      // You can extract more specific error messages if available
      const errorMessage = error.response?.data?.message || 'Erro ao atualizar chave';
      
      toast.error(errorMessage, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000
      });
    }
  },

  async fetchSchema() {
    try {
      const response = await axios.get(`${this.baseURL}/api/v1/schema/atual`);
      if (response.data && response.data.schema) {
        this.currentSchema = response.data.schema; 
      } else {
        this.currentSchema = "Schema não encontrado";
      }
    } catch (error) {
      console.error("Erro ao buscar schema atual:", error);
      this.currentSchema = "Erro ao carregar schema";
    }
  },

    async fetchEmpresaAPI() {
    try {
      // Garante que o schema atual foi carregado antes de buscar os dados da empresa
      if (!this.currentSchema) {
        await this.fetchSchema();
      }
  
      // Usar axios em vez de fetch para aproveitar os interceptors
      const response = await axios.get(`${this.baseURL}/api/v1/empresa/nome/`);
      
      // Com axios, os dados já estão em response.data
      if (response.data) {
        this.api_key = response.data.chave_api || '';
        console.log('API key carregada:', this.api_key);
      }
    } catch (error) {
      console.error('Erro ao buscar dados da empresa:', error);
      toast.error('Erro ao carregar dados da empresa', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000
      });
    }
  },

  
},
}
</script>